export default __webpack_public_path__ + "static/media/lock.b27f4bc8.svg";